/* eslint-disable @typescript-eslint/quotes */
/**
 * PC身份識別頁面
 */
/* eslint-disable no-console */
import React, {
  useRef,
  useState,
  useContext,
  useImperativeHandle,
  forwardRef,
  useEffect,
  useCallback,
} from 'react';
import { useMount } from 'ahooks';
import { Modal, Result, message } from 'antd';
import { useIntl } from 'umi';
import authIcon from '@/assets/authIcon.png';
import classPrefix from 'prefix-classnames';
import { getFirstFaceUrl } from '../../services/serviceStepApi';
import StepContext from '../StepRender/StepContext';
import './WebIdentityAuth.less';

const px = classPrefix('web-auth');
export interface IWebIdentityAuth extends React.HTMLAttributes<HTMLDivElement> {
  onSuccess: () => void;
}

function WebIdentityAuth(props: IWebIdentityAuth, ref) {
  const context = useContext(StepContext);
  const { onSuccess } = props;

  const intl = useIntl();
  const _this = useRef<{
    isFirstFace: boolean;
    secondId: string;
  }>({
    // 是否首次身份識別
    isFirstFace: true,
    // 首次身份識別地址的ID
    secondId: '',
  }).current;

  // 顯示身份識別窗口彈窗
  const [visible, setVisible] = useState<boolean>(false);

  const handleAuth = () => {
    setVisible(true);
    if (_this.isFirstFace) {
      // 首次身份識別
      getFirstFaceUrl({ channel: 'web' }).then((res) => {
        if (!res.success) return;
        // 新窗口打開身份識別地址
        window.open(res.data);
        // 解析身份識別地址上的id參數，用作第二次身份識識別接口掉用餐時
        const str = decodeURIComponent(res.data);
        const index = str.lastIndexOf('id=');
        let id = str.substring(index + 3);
        if (id.includes('&')) {
          const arr: string[] = id.split('&', 1);
          [id] = arr;
        }
        // 将id存储起来
        _this.secondId = id;
      });
    } else {
      // 非首次身份識別
      // eslint-disable-next-line no-alert
      alert('非首次身份識別');
    }
  };

  useMount(() => {
    if (!context.isAuth) {
      handleAuth();
    }
  });

  /**
   * 將handleAuth方法暴露給組件外部掉用
   */
  useImperativeHandle(ref, () => ({
    handleAuth,
  }));

  /**
   * 身份識別成功回調
   * @param code
   * @param id
   */
  const handleSuccess = (code: string, id: string) => {
    setVisible(false);
    message.success(intl.formatMessage({ id: '身份校驗成功' }));
    onSuccess();
  };

  /**
   * 監聽身份識別結果返回
   */
  const receiveMessage = useCallback(
    (event: MessageEvent) => {
      console.log("🚀 ~ WebIdentityAuth ~ event:", event);
      if (!visible) return; // 用户关闭校验窗口
      console.log("WebIdentityAuth:"+ event.data);
      if (event.data) {
        const { type, data } = event.data;
        // 这里假定开发环境一直成功
        const mockTrue = process.env.NODE_ENV === 'development';
        if (mockTrue || (type === 'authMessage' && data.success)) {
          handleSuccess(data.code, data.id);
        } else {
          // pass
          setVisible(false);
          _this.isFirstFace = false;
          message.warning(intl.formatMessage({ id: '身份校驗失敗' }));
        }
      }
    },
    [visible],
  );

  useEffect(() => {
    // 接收postMessage
    window.onmessage = receiveMessage;
    return () => {
      window.onmessage = null;
    };
  }, [receiveMessage]);

  return visible ? (
    <Modal
      className={px('modal')}
      visible={visible}
      footer={null}
      width="400px"
      onCancel={() => {
        setVisible(false);
        message.warning(intl.formatMessage({ id: '取消校驗' }));
      }}
      centered
    >
      <div>{intl.formatMessage({ id: '身份識別中，請勿關閉窗口！' })}</div>
      <img src={authIcon as string} alt="" />
    </Modal>
  ) : (
    context.isAuth && <Result status="success" title={intl.formatMessage({ id: '身份識別成功' })} />
  );
}

export default forwardRef(WebIdentityAuth);
